export default __webpack_public_path__ + "static/media/untitled-12.1d422a13.jpg";